import axios from "axios";
import i18n from "@/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 20000 });

export const photoUrl = (path) => `${API}/photo/${path}`;

// Turns any axios error into a simple, user-friendly localized message.
export const friendlyError = (err, fallback) => {
  if (err?.response?.data?.detail) return err.response.data.detail;
  if (err?.code === "ECONNABORTED") return i18n.t("errors.slow");
  if (err?.message === "Network Error" || !err?.response) return i18n.t("errors.noConnection");
  return fallback || i18n.t("errors.generic");
};

export const REPORTER_LABELS = {
  refugio: "Refugio",
  voluntario: "Voluntario",
  cruz_roja: "Cruz Roja",
  proteccion_civil: "Protección Civil",
  familiar: "Familiar",
};

export const AGE_RANGES = [
  { value: "m0_6", label: "0 a 6 meses" },
  { value: "m6_12", label: "6 a 12 meses" },
  ...Array.from({ length: 17 }, (_, i) => ({
    value: `y${i + 1}`,
    label: `${i + 1} ${i + 1 === 1 ? "año" : "años"}`,
  })),
];

export const ageRangeLabel = (v) => AGE_RANGES.find((r) => r.value === v)?.label || v || "";

export const HANDOFF_INSTITUTIONS = [
  { value: "policia", label: "Policía" },
  { value: "ambulancia", label: "Ambulancia" },
  { value: "refugio", label: "Refugio" },
  { value: "proteccion_civil", label: "Protección Civil" },
  { value: "cruz_roja", label: "Cruz Roja" },
  { value: "otro", label: "Otro" },
];
export const institutionLabel = (v) => HANDOFF_INSTITUTIONS.find((i) => i.value === v)?.label || v || "";

export const getToken = () => localStorage.getItem("reune_admin_token");
export const setToken = (t) => localStorage.setItem("reune_admin_token", t);
export const clearToken = () => localStorage.removeItem("reune_admin_token");

export const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });
